
// Token 存储键名
const TOKEN_KEY = 'userToken';
const DOCTOR_TOKEN_KEY = 'doctor_token';
const GLOBAL_TOKEN_KEY = 'student_global_token';

// /**
//  * 设置 Token
//  * @param {string} token - 后端返回的 Token 字符串
//  */
// export function setToken(token) {
//   if (token) {
//     localStorage.setItem(TOKEN_KEY, token);
//   }
// }

// /**
//  * 获取 Token
//  * @returns {string|null} - 存储的 Token 或 null
//  */
// export function getToken() {
//   return localStorage.getItem(TOKEN_KEY) || null;
// }

// /**
//  * 清除 Token
//  */
// export function removeToken() {
//   localStorage.removeItem(TOKEN_KEY);
// }
// ---------------------- 医生Token操作 ----------------------
export function setToken(token) {
  return localStorage.setItem(DOCTOR_TOKEN_KEY, token);
}

export function getToken() {
  return localStorage.getItem(DOCTOR_TOKEN_KEY);
}

export function removeToken() {
  return localStorage.removeItem(DOCTOR_TOKEN_KEY);
}

// ---------------------- 学生全局Token操作 ----------------------
/**
 * 存储学生全局Token（从学校接口message获取）
 * @param {string} token - 全局Token字符串
 */
export function setGlobalToken(token) {
  return localStorage.setItem(GLOBAL_TOKEN_KEY, token);
}

/**
 * 获取学生全局Token
 * @returns {string|null} 全局Token或null
 */
export function getGlobalToken() {
  return localStorage.getItem(GLOBAL_TOKEN_KEY);
}

/**
 * 删除学生全局Token
 */
export function removeGlobalToken() {
  return localStorage.removeItem(GLOBAL_TOKEN_KEY);
}

/**
 * 判断是否已登录（简单判断 Token 是否存在）
 * @returns {boolean}
 */
export function isLogin() {
  return !!getToken();
}